module.exports = __webpack_public_path__ + "static/media/53.46c517fd.png";